import { render } from "./TableroRouter-respaldo.vue?vue&type=template&id=1fef22d0&scoped=true"
import script from "./TableroRouter-respaldo.vue?vue&type=script&lang=js"
export * from "./TableroRouter-respaldo.vue?vue&type=script&lang=js"

import "./TableroRouter-respaldo.vue?vue&type=style&index=0&id=1fef22d0&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fef22d0"]])

export default __exports__